export const flashCardData = {
	// Violin Data
	"g_string": [
		{noteImg: "/assets/images/singleNotes/low_G.png" , noteBaseName: 'G', midiOctave: 4, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/low_A.png" , noteBaseName: 'A', midiOctave: 4, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/low_B.png" , noteBaseName: 'B', midiOctave: 4, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/low_C.png" , noteBaseName: 'C', midiOctave: 4, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/low_D.png" , noteBaseName: 'D', midiOctave: 4, midiNumber: 14}
	],
	"d_string": [
		{noteImg: "/assets/images/singleNotes/low_D.png" , noteBaseName: 'D', midiOctave: 4, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/mid_E.png" , noteBaseName: 'E', midiOctave: 4, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/mid_F.png" , noteBaseName: 'F', midiOctave: 4, midiNumber: 17},
		{noteImg: "/assets/images/singleNotes/mid_G.png" , noteBaseName: 'G', midiOctave: 5, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/mid_A.png" , noteBaseName: 'A', midiOctave: 5, midiNumber: 9}
	],
	"a_string": [
		{noteImg: "/assets/images/singleNotes/mid_A.png" , noteBaseName: 'A', midiOctave: 5, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/mid_B.png" , noteBaseName: 'B', midiOctave: 5, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/mid_C.png" , noteBaseName: 'C', midiOctave: 5, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/mid_D.png" , noteBaseName: 'D', midiOctave: 5, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/high_E.png", noteBaseName: 'E', midiOctave: 5, midiNumber: 16}
	],
	"e_string": [
		{noteImg: "/assets/images/singleNotes/high_E.png" , noteBaseName: 'E', midiOctave: 5, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/high_F.png" , noteBaseName: 'F', midiOctave: 5, midiNumber: 17},
		{noteImg: "/assets/images/singleNotes/high_G.png" , noteBaseName: 'G', midiOctave: 6, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/high_A.png" , noteBaseName: 'A', midiOctave: 6, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/high_B.png" , noteBaseName: 'B', midiOctave: 6, midiNumber: 11}
	],
	"e_string_high": [
		{noteImg: "/assets/images/singleNotes/high_A.png" , noteBaseName: 'A', midiOctave: 6, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/high_B.png" , noteBaseName: 'B', midiOctave: 6, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/high_C.png" , noteBaseName: 'C', midiOctave: 6, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/high_D.png" , noteBaseName: 'D', midiOctave: 6, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/very_high_E.png" , noteBaseName: 'E', midiOctave: 6, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/very_high_F.png" , noteBaseName: 'F', midiOctave: 6, midiNumber: 17}
	],
	// Piano Data
	"treble_center": [
		{noteImg: "/assets/images/singleNotes/low_C.png" , noteBaseName: 'C', midiOctave: 4, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/low_D.png" , noteBaseName: 'D', midiOctave: 4, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/mid_E.png" , noteBaseName: 'E', midiOctave: 4, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/mid_F.png" , noteBaseName: 'F', midiOctave: 4, midiNumber: 17},
		{noteImg: "/assets/images/singleNotes/mid_G.png" , noteBaseName: 'G', midiOctave: 5, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/mid_A.png" , noteBaseName: 'A', midiOctave: 5, midiNumber: 9}
	],
	"treble_higher": [
		{noteImg: "/assets/images/singleNotes/mid_B.png" , noteBaseName: 'B', midiOctave: 5, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/mid_C.png" , noteBaseName: 'C', midiOctave: 5, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/mid_D.png" , noteBaseName: 'D', midiOctave: 5, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/high_E.png", noteBaseName: 'E', midiOctave: 5, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/high_F.png" , noteBaseName: 'F', midiOctave: 5, midiNumber: 17},
		{noteImg: "/assets/images/singleNotes/high_G.png" , noteBaseName: 'G', midiOctave: 6, midiNumber: 7},
	],
	"treble_lower": [
		{noteImg: "/assets/images/singleNotes/low_G.png" , noteBaseName: 'G', midiOctave: 4, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/low_A.png" , noteBaseName: 'A', midiOctave: 4, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/low_B.png" , noteBaseName: 'B', midiOctave: 4, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/low_C.png" , noteBaseName: 'C', midiOctave: 4, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/low_D.png" , noteBaseName: 'D', midiOctave: 4, midiNumber: 14}
	],
	"treble_very_high": [
		{noteImg: "/assets/images/singleNotes/high_A.png" , noteBaseName: 'A', midiOctave: 6, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/high_B.png" , noteBaseName: 'B', midiOctave: 6, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/high_C.png" , noteBaseName: 'C', midiOctave: 6, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/high_D.png" , noteBaseName: 'D', midiOctave: 6, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/very_high_E.png" , noteBaseName: 'E', midiOctave: 6, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/very_high_F.png" , noteBaseName: 'F', midiOctave: 6, midiNumber: 17}
	],
	"bass_lower": [
		{noteImg: "/assets/images/singleNotes/bass_C.png" , noteBaseName: 'C', midiOctave: 3, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/bass_D.png" , noteBaseName: 'D', midiOctave: 3, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/bass_E.png" , noteBaseName: 'E', midiOctave: 3, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/bass_F.png" , noteBaseName: 'F', midiOctave: 3, midiNumber: 17},
		{noteImg: "/assets/images/singleNotes/bass_G.png" , noteBaseName: 'G', midiOctave: 4, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/bass_A.png" , noteBaseName: 'A', midiOctave: 4, midiNumber: 9}
	],
	"bass_higher": [
		{noteImg: "/assets/images/singleNotes/bass_A.png" , noteBaseName: 'A', midiOctave: 4, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/bass_B.png" , noteBaseName: 'B', midiOctave: 4, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/bass_mid_C.png" , noteBaseName: 'C', midiOctave: 4, midiNumber: 12},
		{noteImg: "/assets/images/singleNotes/bass_mid_D.png" , noteBaseName: 'D', midiOctave: 4, midiNumber: 14},
		{noteImg: "/assets/images/singleNotes/bass_mid_E.png" , noteBaseName: 'E', midiOctave: 4, midiNumber: 16},
	],
	"bass_very_low": [
		{noteImg: "/assets/images/singleNotes/bass_low_E.png" , noteBaseName: 'E', midiOctave: 2, midiNumber: 16},
		{noteImg: "/assets/images/singleNotes/bass_low_F.png" , noteBaseName: 'F', midiOctave: 2, midiNumber: 17},
		{noteImg: "/assets/images/singleNotes/bass_low_G.png" , noteBaseName: 'G', midiOctave: 3, midiNumber: 7},
		{noteImg: "/assets/images/singleNotes/bass_low_A.png" , noteBaseName: 'A', midiOctave: 3, midiNumber: 9},
		{noteImg: "/assets/images/singleNotes/bass_low_B.png" , noteBaseName: 'B', midiOctave: 3, midiNumber: 11},
		{noteImg: "/assets/images/singleNotes/bass_C.png" , noteBaseName: 'C', midiOctave: 3, midiNumber: 12},
	]

}